import { environment } from "../environments/environment";


export class BASE_CONFIG
{
  static readonly IS_DEBUG = !environment.production;
  static readonly LOGGER_URL = environment.loggerUrl;
  static readonly LOG_APP_ID = environment.logAppId;
  static readonly VERSION = environment.version;

  static BROWSER = '';
  static PLATFORM = 'WEB';
  static DEVICE = null;
  static LANGUAGE = 'en';
  static orgId = '';
}